import { ProductController } from '@/controllers/Product';

import { ProductsActionTypes } from './action-types';

export const fetchDesignToOrderProducts = (id: string) => ({
  type: ProductsActionTypes.FETCH_DESIGN_TO_ORDER_ENTRIES.START,
  subtypes: ProductsActionTypes.FETCH_DESIGN_TO_ORDER_ENTRIES,
  promise: () => ProductController.fetchDesignToOrderProducts(id),
});
